export const UPDATING_USER_PICTURE = "UPDATING_USER_PICTURE";
export const UPDATING_USER_PICTURE_SUCCESS = "UPDATING_USER_PICTURE_SUCCESS";
export const UPDATING_USER_PICTURE_ERROR = "UPDATING_USER_PICTURE_ERROR";
export const SETTINGS_USER_CHANGE_INFO = "SETTINGS_USER_CHANGE_INFO";
export const SETTINGS_USER_CHANGE_LASTNAME = "SETTINGS_USER_CHANGE_LASTNAME";
export const SETTINGS_USER_CHANGE_BIO = "SETTINGS_USER_CHANGE_BIO";
export const SETTINGS_USER_CHANGE_JOBDURATION =
  "SETTINGS_USER_CHANGE_JOBDURATION";

export const SETTINGS_USER_CHANGE_LANGUAGE = "SETTINGS_USER_CHANGE_LANGUAGE";

export const SHOW_ALERT = "profileSettings/SHOW_ALERT";
export const HIDE_ALERT = "profileSettings/HIDE_ALERT";

export const GDPR_DELETE_ACCOUNT_REQUESTING = "GDPR_DELETE_ACCOUNT_REQUESTING";
export const GDPR_DELETE_ACCOUNT_SUCCESS = "GDPR_DELETE_ACCOUNT_SUCCESS";
export const GDPR_DELETE_ACCOUNT_ERROR = "GDPR_DELETE_ACCOUNT_ERROR";

export const GDPR_EXPORT_DATA_REQUESTING = "GDPR_EXPORT_DATA_REQUESTING";
export const GDPR_EXPORT_DATA_SUCCESS = "GDPR_EXPORT_DATA_SUCCESS";
export const GDPR_EXPORT_DATA_ERROR = "GDPR_EXPORT_DATA_ERROR";
